import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import {
  SeasonActionsUnion,
  SeasonActionTypes
} from '@core/actions/season.actions';
import { Season } from '@app/models';
import { comparerByAlphabet } from '@app/comparers';
import {
  AuthActionsUnion,
  AuthActionTypes
} from '@app/modules/core/actions/auth.actions';

export interface State extends EntityState<Season> {
  loading: boolean;
  loaded: boolean;
  selectedId: number;
}

export const adapter: EntityAdapter<Season> = createEntityAdapter<Season>({
  selectId: (season: Season) => season.id,
  sortComparer: comparerByAlphabet('ASC', 'name')
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  selectedId: null
});

export function reducer(
  state: State = INITIAL_STATE,
  action: SeasonActionsUnion | AuthActionsUnion
) {
  switch (action.type) {
    case SeasonActionTypes.Load:
      return { ...state, loading: true };

    case SeasonActionTypes.LoadFail:
      return { ...state, loading: false };

    case SeasonActionTypes.LoadSuccess:
      return adapter.addAll(action.seasons, {
        ...state,
        loading: false,
        loaded: true
      });

    case SeasonActionTypes.Select:
      return { ...state, selectedId: action.id };

    // KEEP DEPARTMENTS LOADED ON LOGOUT
    case AuthActionTypes.Logout:
      return { ...state, selectedId: null };

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;
export const selectSelectedId = (state: State) => state.selectedId;
